export const LINKS = {
  instagramLink: 'https://www.instagram.com/pekelna.kuhnya/',
  facebookLink: 'https://www.facebook.com/pekelna.kuhnya.kharkiv',
  linkedInLink: '',
  telegramLink: 'https://t.me/Pekelna_Kuhnia',
  twitterLink: 'https://x.com/HellsKitchenKh?s=20',
  whatsAppLink: 'https://chat.whatsapp.com/ELqGTavDrMk5ToQhjHWh50',
};
